import styled from 'styled-components';

export const ContainerGapDefault = styled.div`
    display: flex;
    flex-direction: column;
    gap: 90px;
`